<template>
  <div class="container py-4">
    <h2>Editar categoría</h2>

    <form @submit="update">
      <div class="form-group mb-3">
        <label class="form-label">Nombre</label>
        <input
          type="text"
          class="form-control"
          v-model="updateCategory.name"
        />
      </div>

      <div class="form-group mb-3">
        <label class="form-label">Temática</label>
        <select
          class="form-select form-control"
          v-model="updateCategory.topic"
        >
          <option :key="t.UUID" v-for="t in topics" :value="t.UUID">
            {{ t.name }}
          </option>
        </select>
      </div>

      <div class="form-group mb-3">
        <label class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="updateCategory.enabled"
          />
          <span class="form-check-label">Activado</span>
        </label>
      </div>

      <div class="mt-3">
        <button type="submit" class="btn btn-primary me-2" :disabled="loading">
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm me-1"
            role="status"
            aria-hidden="true"
          ></span>
          Guardar
        </button>
        <router-link to="/app/blog/categories" class="btn btn-secondary">
          Cancelar
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import CategoryService from "@/services/category.service";
import TopicService from "@/services/topic.service";
import Swal from "sweetalert2";

export default {
  name: "EditCategoryView",
  data() {
    return {
      updateCategory: {
        name: "",
        topic: "",
        enabled: true,
      },
      topics: [],
      loading: false,
    };
  },
  async created() {
    const uuid = this.$route.params.uuid;
    const categoryRes = await CategoryService.getCategory(uuid);
    const category = categoryRes.data;
 
    this.updateCategory = {
      name: category.name,
      topic: category.topic.UUID,
      enabled: category.enabled,
    };

    const topicRes = await TopicService.getAllTopics();
    this.topics = topicRes.data;
  },
  methods: {
    async update(evt) {
      evt.preventDefault();
      this.loading = true;
      const uuid = this.$route.params.uuid;

      const response = await CategoryService.updateCategory(uuid, {
        name: this.updateCategory.name,
        topic: this.updateCategory.topic,
        enabled: this.updateCategory.enabled,
      });

      this.loading = false;

      if (response.status === 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Se ha guardado correctamente.",
          showConfirmButton: false,
          timer: 1500,
          backdrop: false,
          toast: true,
        });
        this.$router.push({ path: "/app/blog", query: { tab: "categories" } });
      }
    },
  },
};
</script>
